// extracted by mini-css-extract-plugin
module.exports = {"headshot":"image-wrapper-module--headshot--26uTa"};